import React, { useCallback, useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import dayjs from "dayjs";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

import moment from "moment";
import GangtokService from "../../services/gangtok.service";
import { useLocation } from "react-router-dom";

const OBTS = ({ depo }) => {
  const location = useLocation();
  const [activeYearly, setActiveYearly] = useState(1);
  const [checked, setChecked] = useState("0");

  const [mainData, setMainData] = useState([]);
  const [cashCollection, setCashCollection] = useState([]);
  const [upiCollection, setUpiCollection] = useState([]);
  const [ticketCountData, setTicketCountData] = useState([]);
  const [loading, setLoading] = useState(false);

  // const fetchTicketCounts = useCallback(() => {
  //   const type = activeYearly.toString();
  //   if (checked === "1") {
  //     setLoading(true);
  //     GangtokService.getObtsCount(type)
  //       .then((resp) => {
  //         setLoading(false);
  //         setTicketCountData(resp.data);
  //       })
  //       .catch((e) => console.log(e));
  //   }
  // }, [activeYearly, checked]);

  // useEffect(() => {
  //   fetchTicketCounts();
  // }, [fetchTicketCounts]);

  const fetchAmtCollection = useCallback(() => {
    const type = activeYearly.toString();
    // console.log("type", type);
    if (checked === "0") {
      setLoading(true);
      GangtokService.getNewOBTS(type, depo)
        .then((resp) => {
          setLoading(false);
          setMainData(resp.data);
          const cash = resp.data.filter((item) => item.mode === "Cash_Fare");
          const upi = resp.data.filter((item) => item.mode === "UPI_Fare");
          if (cash.length != 0) {
            setCashCollection(cash[0].modedata);
          }
          if (upi.length != 0) {
            setUpiCollection(upi[0].modedata);
          }
        })
        .catch((e) => console.log(e));
    }
  }, [activeYearly, checked]);

  useEffect(() => {
    fetchAmtCollection();
  }, [fetchAmtCollection]);

  const handleYearlyFilter = (from) => {
    setActiveYearly(from);
  };

  const generateLast7DaysData = () => {
    if (cashCollection.length != 0) {
      const data = cashCollection.map((item) =>
        moment(item.amounttype, "YYYY-MM-DD").format("DD-MM-YY")
      );
      return data;
    } else {
      return;
    }
  };

  const generateLast7YearsData = () => {
    if (cashCollection.length != 0) {
      const data = cashCollection.map((item) => item.amounttype);
      return data;
    } else {
      return;
    }
  };

  const months = Array.from({ length: dayjs().month() + 1 }, (_, i) =>
    dayjs().month(i).format("MMM")
  );

  const data =
    activeYearly === 1
      ? generateLast7DaysData()
      : activeYearly === 2
      ? months
      : activeYearly === 3
      ? generateLast7YearsData()
      : [];

  const gradient = document.createElement("canvas").getContext("2d");
  const gradientFill = gradient.createLinearGradient(0, 0, 0, 250);
  const gradientFill2 = gradient.createLinearGradient(0, 0, 0, 250);

  gradientFill.addColorStop(0, "rgba(193, 255, 230, 1)"); // Start color
  gradientFill.addColorStop(1, "rgba(255, 255, 255, 1)"); // End color

  gradientFill2.addColorStop(0, "rgba(200, 181, 237, 1)"); // Start color
  gradientFill2.addColorStop(1, "rgba(255, 255, 255, 1)"); // End color

  const collectionData = {
    labels: data,
    datasets: [
      {
        label: `UPI Collection`,
        data:
          upiCollection.length != 0
            ? upiCollection.map((item) => item.amount)
            : null,
        borderColor: "rgb(19, 196, 125)",
        backgroundColor: gradientFill,
        tension: 0.5,
        fill: true,
        borderWidth: 0.5,
      },
      {
        label: "Cash Collection",
        data:
          cashCollection.length != 0
            ? cashCollection.map((item) => item.amount)
            : null,
        borderColor: "rgba(172, 145, 228, 1)",
        backgroundColor: gradientFill2,
        tension: 0.5,
        fill: true,
        borderWidth: 0.5,
      },
    ],
  };

  const ticketCollectedData = {
    labels: data,
    datasets: [
      {
        label: "Ticket Booked",
        data: ticketCountData.map((item) => item.amount),
        backgroundColor: gradientFill2,
        borderColor: "rgba(172, 145, 228, 1)",
        categoryPercentage: 0.34,
        fill: true,
        borderWidth: 1,
        tension: 0.5,
      },
    ],
  };

  const formatter = new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 2,
  });

  const footer = (tooltipItems) => {
    let sum = 0;

    sum = tooltipItems.reduce((summ, item) => {
      return summ + item.parsed.y || 0;
    }, 0);

    if (checked === "0") {
      return `Total Amt: ₹${formatter.format(sum)}\n`;
    } else {
      return;
    }
  };

  const options = {
    responsive: true,
    offset: true,
    stacked: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
        ticks: {
          font: {
            size: 13,
            weight: "bold",
            family: "Jost",
          },
        },
      },
      y: {
        display: true,
        grid: {
          display: true,
        },
        border: {
          display: false,
        },
        title: {
          display: true,
          text: checked === "0" ? "Amount (in ₹)" : "Ticket Count",
        },
      },
    },
    plugins: {
      legend: {
        display: false,
        position: "top",
        align: "end",
        labels: {
          boxWidth: 13,
          useBorderRadius: true,
          borderRadius: "6px",
        },
      },
      tooltip: {
        displayColors: true,
        yAlign: "bottom",
        backgroundColor: "rgba(254, 235, 230, 1)",
        titleColor: "black",
        bodyColor: "black",
        footerColor: "black",
        callbacks: {
          label: function (context) {
            const label = context.dataset.label || "";
            const value = context.formattedValue;
            if (checked === "0") {
              return `${label}: ₹${value}`;
            } else {
              return `${label}: ${value}`;
            }
          },
          beforeBody: footer,
        },
        bodyFont: {
          size: 17,
          family: "Jost, sans-serif",
        },
        titleFont: {
          size: 16,
          family: "Jost, sans-serif",
        },

        // usePointStyle: true,
      },
      datalabels: {
        display: false,
      },
    },
  };

  console.log(cashCollection);
  return (
    <>
      <div className="graph-header">
        <div className="graph-heading">
          <span>OBTS Collection</span>
        </div>
        <div className="graph-yearly-filter">
          <div
            className={activeYearly === 1 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(1)}
          >
            Last 7 Days
          </div>
          <div
            className={activeYearly === 2 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(2)}
          >
            Monthly
          </div>
          <div
            className={activeYearly === 3 ? "filter-box active" : "filter-box"}
            onClick={() => handleYearlyFilter(3)}
          >
            Yearly
          </div>
        </div>
      </div>
      {/* <div className="d-flex justify-content-end gap-2">
        <label class="radio-container">
          Collection
          <input
            type="radio"
            checked={checked === "0"}
            onChange={() => {
              setChecked("0");
            }}
            name="radio"
          />
          <span class="checkmark"></span>
        </label>
        <label class="radio-container">
          Ticket Booked
          <input
            type="radio"
            checked={checked === "1"}
            onChange={() => {
              setChecked("1");
            }}
            name="radio"
          />
          <span class="checkmark"></span>
        </label>
      </div> */}
      <>
        {loading ? (
          <>
            <div className="loading-area">
              <div
                class="spinner-border "
                style={{ color: "rgb(247, 177, 140)" }}
                role="status"
              >
                <span class="sr-only"></span>
              </div>
              <span>Data is Loading...</span>
            </div>
          </>
        ) : mainData.length != 0 ? (
          <>
            <div className="mt-3">
              <Line
                data={collectionData}
                options={options}
                width={600}
                height={275}
              />
            </div>
          </>
        ) : (
          <div className="table-body mt-3" style={{ height: "100%" }}>
            No Records Found
          </div>
        )}
      </>
    </>
  );
};

export default OBTS;
